module.exports = __webpack_public_path__ + "img/paci_ar_4.e673b270.png";